import { render, staticRenderFns } from "./LiveStatus.vue?vue&type=template&id=011fad8c&scoped=true"
import script from "./LiveStatus.vue?vue&type=script&lang=ts"
export * from "./LiveStatus.vue?vue&type=script&lang=ts"
import style0 from "./LiveStatus.vue?vue&type=style&index=0&id=011fad8c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011fad8c",
  null
  
)

export default component.exports